import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    copyCoeditingDocument as GqlCopyCoeditingDocumentResponse,
    copyCoeditingDocumentVariables as GqlCopyCoeditingDocumentVariables,
} from "./__graphql-types__/copyCoeditingDocument.ts";

export const COPY_COEDITING_DOCUMENT_MUTATION: GqlOperation<
    GqlCopyCoeditingDocumentResponse,
    GqlCopyCoeditingDocumentVariables
> = gqlOp(gql`
    mutation copyCoeditingDocument($documentID: String!, $snapshotID: String!) {
        copyCoeditingDocument(
            documentID: $documentID
            snapshotID: $snapshotID
        ) {
            newDocumentID
            error {
                code
            }
        }
    }
`);
